module.exports = __webpack_public_path__ + "static/media/gpay.14c3d799.svg";